/* src/app/features/tarefas/inadimplencia/tarefas-inadimplencia.component.scss */
h5 {
  margin-bottom: 40px;
}
.col-auto {
  margin-top: 15px;
}
.alterarEstado {
  margin-top: 40px;
}
.btn.btn-light {
  margin-top: 4px;
}
.d-flex.title {
  padding-right: 800px;
  font-weight: bold;
}
.d-flex.title2 {
  padding-right: 756px;
  font-weight: bold;
}
.d-flex.title3 {
  padding-right: 888px;
  font-weight: bold;
}
.d-flex.title4 {
  padding-right: 658px;
  font-weight: bold;
}
.d-flex.title5 {
  padding-right: 744px;
  font-weight: bold;
}
.d-flex.title6 {
  padding-right: 620px;
  font-weight: bold;
}
.d-flex.title7 {
  padding-right: 715px;
  font-weight: bold;
}
.erro {
  color: red;
}
.margin-top-10 {
  margin-top: 10px;
}
.form-check-input-salvar-resultado {
  position: relative;
  margin-left: 4px;
  margin-right: 5px;
}
/*# sourceMappingURL=tarefas-inadimplencia.component.css.map */
